import { axios } from "../axiosInstance";
import type { ManageFirmOverviewResponse } from "../interfaces/models/IManageFirmOverview";

export const getManageFirmOverview = async (): Promise<ManageFirmOverviewResponse> => {
  const response = await axios.Get("./manageFirmOverview");
  return response.data as ManageFirmOverviewResponse;
};
